export const Layout = {
  Default: 'default',
  Basic: 'basic',
  Error: 'error',
};
